import { isMobile } from '../helpers/isMobile';
import { gameIds, gameNames } from './enumsByGames';

export const oddsInfoEnumsByGame = {
  [gameIds[gameNames.dazzlingFire5]]: {
    oddsInfoEnumWeb: [
      { id: 0, oddX: -35, oddContainerY: 25, oddsContainerX: 685, oddsContainerY: 290 },
      { id: 1, oddX: -35, oddContainerY: 25, oddsContainerX: 1005, oddsContainerY: 290 },
      { id: 2, oddX: -35, oddContainerY: 25, oddsContainerX: 375, oddsContainerY: 590 },
      { id: 3 },
      { id: 4 },
      { id: 5, oddX: -35, oddContainerY: 25, oddsContainerX: 685, oddsContainerY: 590 },
      { id: 6, oddX: -35, oddContainerY: 25, oddsContainerX: 1005, oddsContainerY: 590 },
      { id: 7, oddX: -35, oddContainerY: 25, oddsContainerX: 375, oddsContainerY: 320 },
    ],
    oddsInfoEnumMobile: [
      { id: 0, oddX: 12, oddContainerY: 15, oddsContainerX: 114, oddsContainerY: 585 },
      { id: 1, oddX: 12, oddContainerY: 15, oddsContainerX: 374, oddsContainerY: 585 },
      { id: 2, oddX: 12, oddContainerY: 15, oddsContainerX: 114, oddsContainerY: 825 },
      { id: 3 },
      { id: 4 },
      { id: 5, oddX: 12, oddContainerY: 15, oddsContainerX: 374, oddsContainerY: 825 },
      { id: 6, oddX: 12, oddContainerY: 15, oddsContainerX: 255, oddsContainerY: 1075 },
      { id: 7, oddX: 12, oddContainerY: 15, oddsContainerX: 255, oddsContainerY: 340 },
    ],
  },
  [gameIds[gameNames.dazzlingFire20]]: {
    oddsInfoEnumWeb: [
      { id: 0, oddX: -35, oddContainerY: 25, oddsContainerX: 685, oddsContainerY: 290 },
      { id: 1, oddX: -35, oddContainerY: 25, oddsContainerX: 1005, oddsContainerY: 290 },
      { id: 2, oddX: -35, oddContainerY: 25, oddsContainerX: 375, oddsContainerY: 590 },
      { id: 3 },
      { id: 4 },
      { id: 5, oddX: -35, oddContainerY: 25, oddsContainerX: 685, oddsContainerY: 590 },
      { id: 6, oddX: -35, oddContainerY: 25, oddsContainerX: 1005, oddsContainerY: 590 },
      { id: 7, oddX: -35, oddContainerY: 25, oddsContainerX: 375, oddsContainerY: 320 },
    ],
    oddsInfoEnumMobile: [
      { id: 0, oddX: 12, oddContainerY: 15, oddsContainerX: 114, oddsContainerY: 585 },
      { id: 1, oddX: 12, oddContainerY: 15, oddsContainerX: 374, oddsContainerY: 585 },
      { id: 2, oddX: 12, oddContainerY: 15, oddsContainerX: 114, oddsContainerY: 825 },
      { id: 3 },
      { id: 4 },
      { id: 5, oddX: 12, oddContainerY: 15, oddsContainerX: 374, oddsContainerY: 825 },
      { id: 6, oddX: 12, oddContainerY: 15, oddsContainerX: 255, oddsContainerY: 1075 },
      { id: 7, oddX: 12, oddContainerY: 15, oddsContainerX: 255, oddsContainerY: 340 },
    ],
  },
};

export const payTableStepsContentByGame = {
  [gameIds[gameNames.dazzlingFire5]]: {
    step0: {
      id: 0,
      titleY: 59,
      text: 'SYMBOL_PAYOUT',
      contentImage: 'payTableStep0Image',
      stepInfoText: [],
      y: 0,
    },
    step1: {
      id: 1,
      text: 'WINNING_LINES',
      contentImage: 'payTableStep1Image',
      stepInfoText: [
        {
          x: isMobile() ? 270 : 2160,
          y: isMobile() ? 1500 : 675,
          anchor: 0.5,
          type: 'text',
          align: 'center',
          wordWrapWidth: isMobile() ? 394 : 687,
          text: 'WINNING_LINES_TEXT',
        },
      ],
      y: isMobile() ? 1207 : 1527,
    },
    step2: {
      isHide: false,
      id: 2,
      text: 'JACKPOT',
      contentImage: 'payTableStep2Image',
      stepInfoText: [
        {
          x: isMobile() ? 270 : 3600,
          y: isMobile() ? 1970 : 675,
          anchor: 0.5,
          type: 'text',
          align: 'center',
          wordWrapWidth: isMobile() ? 394 : 687,
          text: 'JACKPOT_INTRO',
        },
      ],
      y: isMobile() ? 1570 : 1469,
    },
  },
  [gameIds[gameNames.dazzlingFire20]]: {
    step0: {
      id: 0,
      titleY: 59,
      text: 'SYMBOL_PAYOUT',
      contentImage: 'payTableStep0Image',
      stepInfoText: [],
      y: 0,
    },
    step1: {
      id: 1,
      text: 'WINNING_LINES',
      contentImage: 'payTableStep1Image',
      stepInfoText: [
        {
          x: isMobile() ? 270 : 2160,
          y: isMobile() ? 1720 : 675,
          anchor: 0.5,
          type: 'text',
          align: 'center',
          wordWrapWidth: isMobile() ? 394 : 687,
          text: 'WINNING_LINES_TEXT',
        },
      ],
      y: isMobile() ? 1207 : 1527,
    },
    step2: {
      isHide: false,
      id: 2,
      text: 'JACKPOT',
      contentImage: 'payTableStep2Image',
      stepInfoText: [
        {
          x: isMobile() ? 270 : 3600,
          y: isMobile() ? 2160 : 675,
          anchor: 0.5,
          type: 'text',
          align: 'center',
          wordWrapWidth: isMobile() ? 394 : 687,
          text: 'JACKPOT_INTRO',
        },
      ],
      y: isMobile() ? 1770 : 1469,
    },
  },
};

export const payTableOddsByGameId = {
  [gameIds[gameNames.dazzlingFire5]]: [
    [1000, 200, 20],
    [100, 40, 10],
    [100, 40, 10],
    [40, 10, 4],
    [40, 10, 4],
    [40, 10, 4],
    [40, 10, 4, 1],
    [50, 10, 2]
  ],
  [gameIds[gameNames.dazzlingFire20]]: [
    [1000, 200, 10],
    [25, 10, 2.5],
    [25, 10, 2.5],
    [10, 2.5, 1],
    [10, 2.5, 1],
    [10, 2.5, 1],
    [10, 2.5, 1, 0.25],
    [50, 10, 2]
  ],
}

export const gameRulesKeysByGameId = [
  { key: 'ABOUT_THE_GAME', type: 'title' },
  { key: 'ABOUT_THE_GAME_P1', type: 'text' },
  { key: 'GENERAL_INFORMATION', type: 'title' },
  { key: 'QUICK_INFO_MATRIX_SIZE', type: 'text', isCircle: true },
  { key: 'QUICK_INFO_PAY_LINE', type: 'text', isCircle: true },
  { key: 'QUICK_INFO_RTP', type: 'text', isCircle: true, hasLicenseCheck: true },
  { key: 'RTP_GLI', type: 'text', isCircle: true, hasLicenseCheck: false },
  { key: 'QUICK_INFO_VOLATILITY', type: 'text', isCircle: true },
  { key: 'QUICK_INFO_MIN_BET', type: 'text', valueKey: 'minBet', isCircle: true, isCurrency: true, isLicense: true },
  { key: 'QUICK_INFO_MAX_BET', type: 'text', valueKey: 'maxBet', isCircle: true, isCurrency: true, isLicense: true },
  { key: 'QUICK_INFO_MAX_ODD', type: 'text', valueKey: 'maxOdd', isCircle: true, hasLicenseCheck: true },
  { key: 'GAME_INFO_HOW_TO_PLAY', type: 'title' },
  { key: 'HOW_TO_PLAY_P1', type: 'text' },
  { key: 'HOW_TO_PLAY_P2', type: 'text' },
  { key: 'GAME_RULES_GAME_FEATURES', type: 'title' },
  { key: 'WILD', type: 'title' },
  { key: 'WILDS_TEXT', type: 'text' },
  { key: 'WILD_RULES_P1', type: 'text' },
  { key: 'AUTO_PLAY', type: 'title', hasAutoCheck: false },
  { key: 'AUTO_SPIN_P1', type: 'text', hasAutoCheck: false },
  { key: 'AUTO_SPIN_P2', type: 'text', hasAutoCheck: false },
  { key: 'AUTO_SPIN_P3', type: 'text', hasAutoCheck: false },
  { key: 'AUTO_SPIN_P4', type: 'text', hasAutoCheck: false },
  { key: 'TURBO_MODE', type: 'title' },
  { key: 'TURBO_MODE_P1', type: 'text' },
  { key: 'CONNECTIVITY_AND_MALFUNCTION', type: 'title' },
  { key: 'MALFUNCTION', type: 'text' },
  { key: 'GAMBLE_FEATURE_TITLE', type: 'title', hasGambleCheck: false },
  { key: 'GAMBLE_FEATURE_TEXT', type: 'text', hasGambleCheck: false },
  { key: 'GAMBLE_VALIDATIONS', type: 'title', hasGambleCheck: false },
  { key: 'GAMBLE_FEATURE_VALIDATIONS_TEXT', type: 'text', hasGambleCheck: false },
]

export const licenseRulesKeysByGameId = [
  { key: null, type: null, textureName: ['spinButton'], isSprite: true, scale: 0 },
  { key: 'GAME_CONTROLS', type: 'title', licenseRules: false },
  { key: null, type: null, textureName: ['spinButton'], isSprite: true, scale: 0.4 },
  { key: 'GAME_CONTROLS_P1', type: 'text', licenseRules: true },
  { key: null, type: null, textureName: ['spinStopButton'], isSprite: true, scale: 0.4 },
  { key: 'GAME_CONTROLS_P2', type: 'text', licenseRules: true },
  {
    key: null,
    type: null,
    textureName: ['quickBetButton'],
    isSprite: true,
    scale: 0.4,
    isSmallSprite: true,
  },
  { key: 'GAME_CONTROLS_P3', type: 'text', licenseRules: true },
  { key: null, type: null, textureName: ['quickBetsListButton'], isSprite: true, scale: 0.4 },
  { key: 'GAME_CONTROLS_P4', type: 'text', licenseRules: true },
  {
    key: null,
    type: null,
    textureName: ['autoSpinButton'],
    isSprite: true,
    scale: 0.4,
    hasAutoCheck: false,
  },
  { key: 'GAME_CONTROLS_P5', type: 'text', licenseRules: true, hasAutoCheck: false },
  {
    key: null,
    type: null,
    textureName: ['speedStandard', 'speedFast', 'speedTurbo'],
    isSprite: true,
    scale: 0.4,
  },
  { key: 'GAME_CONTROLS_P6', type: 'text', licenseRules: true, speedText: true },
  { key: null, type: null, textureName: ['burgerIconLicense'], isSprite: true, scale: 0.4 },
  { key: 'GAME_CONTROLS_P7', type: 'text', licenseRules: true, isMobileCheck: true },
  {
    key: null,
    ype: null,
    textureName: ['fullScreenIconLicense'],
    isSprite: true,
    scale: 0.4,
    isMobileCheck: true,
  },
  { key: 'GAME_CONTROLS_P8', type: 'text', licenseRules: true },
  {
    key: null,
    type: null,
    textureName: ['soundOnIconLIcense', 'soundOffIconLIcense'],
    isSprite: true,
    scale: 0.4,
  },
  { key: 'GAME_CONTROLS_P9', type: 'text', licenseRules: true, soundsText: true },
  { key: null, type: null, textureName: ['rulesIconLicense'], isSprite: true, scale: 0.4 },
  { key: 'GAME_CONTROLS_P10', type: 'text', licenseRules: true },
  {
    key: null,
    type: null,
    textureName: ['historyIconLicense'],
    isSprite: true,
    scale: 0.4,
    isDemoCheck: true,
  },
  { key: 'GAME_CONTROLS_P12', type: 'text', licenseRules: true },
  { key: null, type: null, textureName: ['payTableIconLicense'], isSprite: true, scale: 0.4 },
  { key: 'GAME_CONTROLS_P11', type: 'text', licenseRules: true },
  { key: null, type: null, textureName: ['spinButton'], isSprite: true, scale: 0 },
  { key: 'GAMBLE_CONTROLS', type: 'title', licenseRules: false, hasGambleCheck: false },
  {
    key: null,
    type: null,
    textureName: ['x2'],
    isSprite: true,
    hasGambleCheck: false,
    scale: 0.4,
  },
  { key: 'GAMBLE_CONTROLS_P1', type: 'text', licenseRules: true, hasGambleCheck: false },
  {
    key: null,
    type: null,
    textureName: ['spinCollectButton'],
    isSprite: true,
    scale: 0.4,
    hasGambleCheck: false,
  },
  { key: 'GAMBLE_CONTROLS_P2', type: 'text', licenseRules: true, hasGambleCheck: false },
  {
    key: null,
    type: null,
    textureName: ['jackpotButtonBlack'],
    isSprite: true,
    scale: 0.4,
    isSmallSprite: true,
    hasGambleCheck: false,
  },
  { key: 'GAMBLE_CONTROLS_P3', type: 'text', licenseRules: true, hasGambleCheck: false },
  {
    key: null,
    type: null,
    textureName: ['jackpotButtonRed'],
    isSprite: true,
    scale: 0.4,
    isSmallSprite: true,
    hasGambleCheck: false,
  },
  { key: 'GAMBLE_CONTROLS_P4', type: 'text', licenseRules: true, hasGambleCheck: false },
]
